﻿import controller from "../../../../Resources/Scripts/_Shared/controller";
import { setSearchHistory } from "../../../../Resources/Scripts/_Shared/history";

function myaimoparkloadmore(context) {
    const DEFAULT_INCREMENT = 10;
    const style_element = document.createElement("STYLE");
    const list = context.querySelector("[data-list]");
    const button = context.querySelector("[data-load-more]");
    let observer;

    const containerId =
        context.dataset.loadmoreId ||
        `loadmore-${Math.random().toString(36).slice(2, 11)}`;
    const itemIncrement =
        parseInt(context.dataset.increment, 10) || DEFAULT_INCREMENT;
    const initialItems =
        parseInt(context.dataset.initialItems, 10) || itemIncrement;

    let itemsToShow = initialItems;
    let buttonClick = false;

    function init() {
        if (!list || !button) return;

        const urlParams = new URLSearchParams(window.location.search);
        const paramName = `items-${containerId}`;
        const storedItems = urlParams.get(paramName);

        if (storedItems) {
            itemsToShow = Math.max(initialItems, parseInt(storedItems, 10));
        }

        list.dataset.items = itemsToShow;

        if (list.children.length > itemIncrement) {
            button.addEventListener("click", handleButtonClick);
            document.head.appendChild(style_element);

            observer = new MutationObserver(observerCallback);
            observer.observe(list, { attributes: true });
        }

        updateVisibility();
        updateHistory();
    }

    const handleButtonClick = () => {
        buttonClick = true;
        itemsToShow += itemIncrement;
        list.dataset.items = itemsToShow;
        setTimeout(() => (buttonClick = false), 250);
    };

    const observerCallback = () => {
        if (
            !buttonClick &&
            list.dataset.items &&
            parseInt(list.dataset.items) !== itemsToShow
        ) {
            itemsToShow = parseInt(list.dataset.items);
        }
        updateVisibility();
        updateHistory();
    };

    const updateVisibility = () => {
        const itemsCount = list.children.length;
        const showItems = Math.min(itemsToShow, itemsCount);

        Array.from(list.children).forEach((item, index) => {
            item.style.display = index < showItems ? "flex" : "none";
        });

        button.style.display = itemsToShow >= itemsCount ? "none" : "block";
        button.setAttribute("aria-hidden", itemsToShow >= itemsCount);
    };

    const updateHistory = () => {
        const paramName = `items-${containerId}`;
        const shouldPersist = itemsToShow > initialItems;
        const currentParams = new URLSearchParams(window.location.search);

        // Always update URL when items change
        if (shouldPersist) {
            currentParams.set(paramName, itemsToShow);
        } else {
            currentParams.delete(paramName);
        }

        // Use pushState to ensure URL changes are visible
        const newUrl = `${
            window.location.pathname
        }?${currentParams.toString()}`;
        window.history.pushState({}, "", newUrl);

        // Optional: Force scroll position maintenance
        window.scrollTo(window.scrollX, window.scrollY);
    };

    const destroy = () => {
        if (observer) observer.disconnect();
        button.removeEventListener("click", handleButtonClick);
        if (style_element.parentNode)
            style_element.parentNode.removeChild(style_element);
    };

    return { init, destroy };
}

controller.add("myaimopark-loadmore", myaimoparkloadmore);
